import React from 'react';
import { motion } from "framer-motion";
import sb from "../Images/sb.png";
import Footer from '../components/footer';


const About = () => {
    return ( 
        <>
       <motion.div div id="About"
       style={{
           width:'100%',
           height:'100%',
       }}
       >
           <motion.div 
           style={{
      width:'100%',
      height:'100%',
        }}
           >
<div>
    <div>
        <h1>Sharjeel Baig</h1>
        <p>A coder, significantly a full stack-developer or a super skilled software engineer</p>
    </div>
</div>

<div className="horizontalLayout" style={{width:'100%' ,}}>
    <div style={{width:'100%',}}>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
    <p>Name: Sharjeel</p>
    <p>Full Name: Muhammad Sharjeel Baig</p>
    <p>Born: 10 April 2003</p>
    <p>Occupation: Programmer</p>
    <p>Cast: Baig</p>
    <p>Nationality: Pakistani</p>
    <p>Place of residence: Karachi and Hyderabad</p>
    </div>
<img src={sb} style={{width:'20%',}} />
</div>

<hr />
<br />

<div>
<h1>Early Life</h1>
<p>I was born in Pakistan in 2003, but later on when I was 2 years of age me along with my Family, shifted to Saudia Arabia and My Early life passed their. I started programming when I was almost 11 or 12 years old but in that age, I did not got any professional skills in Programming.That time, I used to code in my tablet and does not used PC to code and used to learn coding by copying and pasting others codes.</p>
</div>
<hr />
<br />
<div>
    <h1>Life as coder</h1>
    <p>
        I returned to Pakistan at the age of 16 .And at the age of 17, I became super skilled coder with the knowledge of both frontend and backend programming languages, I am a self-taught full-stack developer, learned almost every worthy programming languages such as HTML,CSS,Javascript,C#,Java,Python.

    </p>
</div>


</motion.div>
           </motion.div>
           <br />
<br /><br />
<br /><br />
<br /><br />
<br />
           <Footer />
        </>
     );
}
 
export default About;

